import lessRequire from '../../../../config/less-require-resolver';
import React from  'react';
import PropTypes from 'prop-types';
import classname from 'classname';
import { Field } from 'redux-form';

import inputField from '../../../shared/form-elements/input';

import { Link } from 'react-router';
import { baseUrl } from '../../../../config/route-entry-point';

lessRequire('modules/streams/components/stream-form/part-additional.less');

const PartAdditional = (props) => {
	const { active, list } = props.sections;
	const { intl } = props;
	const className = classname({
		'stream-form__additional': true,
		'active': active === list.additional
	});

	return (
		<div className={className}>

			{ props.isOtherAdv && (
				<div className="stream-form__additional-row">
					<Field name="trafficback_url"
						placeholder={intl('Траффикбэк URL')}
						component={inputField}
						errors={props.formData.errors}
						shouldDisable={props.isEditMode && !props.canEdit}
					/>
				</div>
			) }
			{ props.landingSnippets && props.landingSnippets.map(snippet => (
				<div className="stream-form__snippets" key={snippet.id}>
					<div className="stream-form__snippets-item">
						<Field name={`transit_snippet_${snippet.external_id}`}
							placeholder={`${intl('Транзитка')} (${snippet.name})`}
							component={inputField}
							shouldDisable={props.isEditMode && !props.canEdit}
						/>
					</div>
					<div className="stream-form__snippets-item">
						<Field name={`landing_snippet_${snippet.external_id}`}
							placeholder={`${intl('Лендинг')} (${snippet.name})`}
							component={inputField}
							shouldDisable={props.isEditMode && !props.canEdit}
						/>
					</div>

					<div className="stream-form__snippets-item">
						<Field name={`thankyoupage_snippet_${snippet.external_id}`}
							placeholder={`${intl('ThankYouPage')} (${snippet.name})`}
							component={inputField}
							shouldDisable={props.isEditMode && !props.canEdit}
						/>
					</div>
				</div>
			)) }

			<div className="stream-form__additional-row utm-checkbox">
				<div className="utm-settings-title font-proxima-nova-bold">
					{intl('UTM метки вместо SID')}
				</div>

				<div className="utm_fields_container">
					<div className="left">
						<div className="stream-form__additional-row stream-form__additional-inline">
							<Field name="sid1_utm"
								placeholder="sid1"
								value="utm_content"
								component={inputField}
								shouldDisable={props.isEditMode && !props.canEdit}
							/>
						</div>

						<div className="stream-form__additional-row stream-form__additional-inline">
							<Field name="sid2_utm"
								placeholder="sid2"
								value="utm_medium"
								component={inputField}
								shouldDisable={props.isEditMode && !props.canEdit}
							/>
						</div>

						<div className="stream-form__additional-row stream-form__additional-inline">
							<Field name="sid3_utm"
								placeholder="sid3"
								value="utm_source"
								component={inputField}
								shouldDisable={props.isEditMode && !props.canEdit}
							/>
						</div>

						<div className="stream-form__additional-row stream-form__additional-inline">
							<Field name="sid4_utm"
								placeholder="sid4"
								value="utm_campaign"
								component={inputField}
								shouldDisable={props.isEditMode && !props.canEdit}
							/>
						</div>

						<div className="stream-form__additional-row stream-form__additional-inline">
							<Field name="sid5_utm"
								placeholder="sid5"
								component={inputField}
								shouldDisable={props.isEditMode && !props.canEdit}
							/>
						</div>
					</div>

					<div className="right info clearfix">
						<div className="info__right info__highlight">
							<p>
								{intl('Некоторые рекламные системы используют utm-метки и подставляют их к партнерской ссылке')}
							</p>
							<p>&nbsp;</p>
							<p>
								<i>
									{intl('В случае, если в url был передан sid и соответствующая ему метка (например')}
									{' '}
									<b>sid1</b>=a1&<b>utm_content</b>=b1),
									{' '}
									{intl('предпочтение отдается параметру sid.')}
								</i>
							</p>
						</div>
					</div>
				</div>
			</div>

			<div className="stream-form__additional-btns">
				<Link to={baseUrl('campaigns/')} className="button stream-back font-proxima-nova-semibold">
					{intl('Назад')}
				</Link>
				{
					props.isNewOrEditingActiveCampaign && (
						(props.isEditMode && !props.canEdit) ?
							<button className={classname({
								'button stream-submit font-proxima-nova-semibold': true,
								'disabled-btn': props.isSaveLoader
							})}>
								{intl('Клонировать поток')}
							</button> :
							<button className={classname({
								'button stream-submit font-proxima-nova-semibold': true,
								'disabled-btn': props.isSaveLoader
							})}>
								{props.isSaveLoader ? intl('Сохраняю поток') : intl('Сохранить поток')}
							</button>
					)
				}
			</div>
		</div>
	);
};

PartAdditional.propTypes = {
	sections: PropTypes.object,
	formData: PropTypes.object,
	landingSnippets: PropTypes.array,
	isOtherAdv: PropTypes.bool,
	isSaveLoader: PropTypes.bool,
	isEditMode: PropTypes.bool,
	canEdit: PropTypes.bool,
	isNewOrEditingActiveCampaign: PropTypes.bool,
	intl: PropTypes.func
};

export default PartAdditional;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/part-additional.js